import React from 'react';
import {
  FormattedRichMessage,
  CIAMLinkButton,
  ContentPage,
  useRealm,
  useRichIntl,
  customStyles,
} from 'ciam-self-service-shared';
import Page, { AUTH_TYPE } from 'components/common/Page';
import { H2, BUTTON_VARIANT } from '@manulife/mux';
import FormElement from 'components/common/FormElement';
import { ABOUT_PAGE_LOAD } from './constants';
import AnalyticsDataLayer from '../common/Analytics';
import SigninButton from '../common/SigninButton';
import { getPageMetadata } from 'utils/pageMetadata';

function AboutManulifeId() {
  const richIntl = useRichIntl();
  const realm = useRealm();
  const { description } = getPageMetadata('aboutmanulifeid.page', richIntl, realm, { realm });
  return (
    <Page
      title={richIntl.formatMessage({ id: 'aboutmanulifeid.page.title' })}
      description={description}
      heading={richIntl.formatMessage({ id: 'aboutmanulifeid.page.heading' })}
      authType={AUTH_TYPE.UNAUTHENTICATED}
    >
      <AnalyticsDataLayer pageName={ABOUT_PAGE_LOAD} />
      <ContentPage
        title={richIntl.formatMessage({ id: 'aboutmanulifeid.page.title' })}
        heading={<FormattedRichMessage id="aboutmanulifeid.page.heading" />}
      >
        <div>
          <FormattedRichMessage id="aboutmanulifeid.page.paragraph" />
        </div>
        <FormElement spacing={2}>
          <CIAMLinkButton
            to="/register"
            customStyle={customStyles.button}
            analyticsData={{
              click: {
                linkName: richIntl.formatMessage({ id: 'aboutmanulifeid.page.gosignup.button' }),
                linkHref: '/register',
              },
            }}
          >
            <FormattedRichMessage id="aboutmanulifeid.page.gosignup.button" />
          </CIAMLinkButton>
        </FormElement>
        <H2>
          <FormattedRichMessage id="aboutmanulifeid.page.haveid" />
        </H2>
        <FormElement spacing={2}>
          <SigninButton variant={BUTTON_VARIANT.SECONDARY}>
            <FormattedRichMessage id="aboutmanulifeid.page.gosignin.button" />
          </SigninButton>
        </FormElement>
      </ContentPage>
    </Page>
  );
}

export default AboutManulifeId;
